t = require('views/internal/teacup-with-helpers')('select_labels')

module.exports = ->
  t.mustacheBlock 'labels', ->
    t.li ->
      t.mustacheBlock '__ed', ->
        t.a '.card-label-edit-button.icon-sm.icon-edit.js-edit-label', { href: '#', 'data-idlabel': t.mustacheVar('id') }
      t.span { class: 'card-label mod-selectable card-label-' + t.mustacheVar('color') + ' ' + t.mustacheBlock('isActive', (-> 'active')) + ' js-select-label', 'data-idlabel': t.mustacheVar('id'), 'data-color': t.mustacheVar('color') }, ->
        t.mustacheBlock 'name', ->
          t.text t.mustacheVar('name')
        t.icon 'check', { class: 'card-label-selectable-icon light' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/select_labels.coffee